import { render, staticRenderFns } from "./ScratchCard.vue?vue&type=template&id=00cb025c&scoped=true"
import script from "./ScratchCard.vue?vue&type=script&lang=js"
export * from "./ScratchCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb025c",
  null
  
)

export default component.exports